/**
 * Email Header Template Helper
 * Generates properly formatted email headers with centered, linked logo
 */

export const getDefaultEmailHeaderHTML = (): string => {
  return `<table width="100%" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #002E62 0%, #001d3d 100%); padding: 30px 20px;">
  <tr>
    <td align="center">
      <a href="https://recruitlook.com" target="_blank" style="display: inline-block; max-width: 600px; width: 100%;">
        <img src="https://pvaumvowzncvrdkkvnqq.supabase.co/storage/v1/object/public/email-images/recruitlook-logo.png" alt="RecruitLook - We Scout. We Evaluate. We Educate. We Guide." style="display: block; width: 100%; max-width: 600px; height: auto; margin: 0 auto;" />
      </a>
    </td>
  </tr>
</table>`;
};

/**
 * Get header HTML with custom link
 */
export const getEmailHeaderHTMLWithLink = (linkUrl: string = 'https://recruitlook.com'): string => {
  return `<table width="100%" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #002E62 0%, #001d3d 100%); padding: 30px 20px;">
  <tr>
    <td align="center">
      <a href="${linkUrl}" target="_blank" style="display: inline-block; max-width: 600px; width: 100%;">
        <img src="https://pvaumvowzncvrdkkvnqq.supabase.co/storage/v1/object/public/email-images/recruitlook-logo.png" alt="RecruitLook - We Scout. We Evaluate. We Educate. We Guide." style="display: block; width: 100%; max-width: 600px; height: auto; margin: 0 auto;" />
      </a>
    </td>
  </tr>
</table>`;
};

/**
 * Get simple text header (fallback)
 */
export const getSimpleEmailHeaderHTML = (): string => {
  return `<table width="100%" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #002E62 0%, #001d3d 100%); padding: 40px 30px; text-align: center;">
  <tr>
    <td>
      <a href="https://recruitlook.com" target="_blank" style="text-decoration: none;">
        <h1 style="color: #BC8D09; margin: 0; font-size: 32px; font-weight: bold;">RecruitLook</h1>
        <p style="color: #ffffff; margin: 10px 0 0 0; font-size: 16px;">We Scout. We Evaluate. We Educate. We Guide.</p>
      </a>
    </td>
  </tr>
</table>`;
};
